import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FC, useCallback } from 'react'
import { FilterByAccountPane } from 'components/features/pageFilters/FilterByAccountPane/FilterByAccountPane'
import { PageFilterPane } from 'components/features/pageFilters/types'

type PageFiltersPaneHostProps = {
  pane: PageFilterPane
}
export const PageFiltersPaneHost: FC<PageFiltersPaneHostProps> = (props) => {
  const { pane } = props

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
  }, [dispatch])

  switch (pane.mode) {
    case 'by-account': {
      return (
        <FilterByAccountPane page={ pane.page } onClose={ handleClose } />
      )
    }
  }

  return (
    <></>
  )
}
